import React, { useCallback, useState } from "react";
import ModalContext from "./context";

export default function ModalWrapper({
  children,
  ...rest
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalChildren, setModalChildren] = useState(<></>);

  const openModal = useCallback(
    ({ title, modalContents }) => {
      setIsOpen(true);
      setModalTitle(title);
      setModalChildren(modalContents);
    },
    [setIsOpen, setModalChildren, setModalTitle]
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setModalTitle("");
    setModalChildren(<></>);
  }, [setIsOpen, setModalChildren, setModalTitle]);

  return (
    <ModalContext.Provider
      value={{
        openModal,
        closeModal,
        isOpen,
        modalChildren,
        modalTitle,
      }}
      {...rest}
    >
      {children}
    </ModalContext.Provider>
  );
}
